module.exports = __webpack_public_path__ + "img/svea_christiansen_9.c7739319.jpg";